import { FC, ReactNode } from "react";

interface ButtonProps {
    title?: ReactNode;
    onClick?: () => void;
    href?: string;
    disabled?: boolean;
    inverted?: boolean;
    target?: string;
    tooltip?: string;
    className?: string;
    size?: 'xs' | 'base' | 'large';
}

export const Button: FC<ButtonProps> = ({
    title,
    onClick,
    href,
    disabled,
    inverted,
    target = '_self',
    tooltip = '',
    className = '',
    size = 'base',
}) => {
    let classNames = 'transition-all border-2 border-solid border-white cursor-pointer font-bold rounded-full no-underline uppercase duration-200 select-none active:scale-95';
    let linkClassNames = 'block w-fit no-underline hover:no-underline';
    if (disabled) {
        classNames += ' opacity-50 cursor-not-allowed';
        linkClassNames += ' cursor-not-allowed';
        tooltip = 'Скоро будет доступно';
        href = undefined;
        onClick = undefined;
    }

    if (size === 'xs') {
        classNames += ' py-1 px-2 text-lg';
    } else {
        classNames += ' py-4 px-6 text-xl';
    }

    if (inverted) {
        classNames += " bg-slate-950 text-white hover:bg-white hover:text-slate-950";
    } else {
        classNames += " bg-white text-slate-950 hover:bg-slate-950 hover:text-white";
    }

    if (className) {
        classNames += ` ${className}`;
        linkClassNames += ` ${className}`;
    }

    if (href) {
        return (
            <a href={href} className={linkClassNames} target={target} title={tooltip}>
                <div className={classNames} onClick={onClick}>
                    {title}
                </div>
            </a>
        )
    }

    return (
        <div className={classNames} onClick={onClick} title={tooltip}>
            {title}
        </div>
    )
}
